<table [style.border-color]="lighterShade">
  <thead>
    <tr>
      <th class="header" *ngFor="let titleGroup of titleGroups" [attr.colspan]="titleGroup.span">
        {{ titleGroup.title }}
      </th>
    </tr>
    <tr class="header">
      <th *ngFor="let title of titleArray; let index = index">
        <span *ngIf="index === 0">&nbsp;</span>
        {{ title }}
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let object of dataArray; let tableIndex = index">
      <tr (click)="expand(tableIndex)">
        <td *ngFor="let field of object | keyvalue: originalOrder; let index = index" class="values">
          <mat-icon *ngIf="index === 0 && expandable" class="expandable">{{
            expandedIndexes.includes(tableIndex) ? 'expand_more' : 'chevron_right'
          }}</mat-icon>
          {{ field.value }}</td>
      </tr>
      <ng-container *ngIf="expandedIndexes.includes(tableIndex)">
        <tr style="background-color: white">
          <td [attr.colspan]="titleArray.length">
            <div *ngFor="let table of expandedTables[tableIndex]">
              <table class="inner-table">
                <tr *ngFor="let titleRow of table.titles" class="inner-header">
                  <th *ngFor="let title of titleRow" [attr.colspan]="title.span" class="inner-header-cell">
                    {{ title.title }}
                  </th>
                </tr>
                <tr>
                  <td *ngFor="let data of table.data" class="inner-cell">{{ data }}</td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </ng-container>
    </ng-container>
    <tr *ngIf="useSummaryRow && dataArray.length > 0" class="sum-row">
      <td *ngFor="let field of summaryRowData | keyvalue: originalOrder">{{ field.value }}</td>
    </tr>
  </tbody>
</table>
